<div class="popup-containers">

  <button mat-icon-button mat-dialog-close class="btn-close-popups">X</button>

  <!-- Dialog title -->
  <h2 mat-dialog-title class="mb-3">{{ title }}</h2>

  <!-- Dialog content -->
  <mat-dialog-content>
    <div class="analytics-popup">
      <div class="modal-body">

        <div class="row py-2">
          <div class="col-4"><strong>Source</strong></div>
          <div class="col-4"><strong>{{metricsName}}</strong></div>
          <div class="col-4 hide-duration" *ngIf="dataToShow[0]['duration']"><strong>Duration (HH:MM:SS)</strong></div>
        </div>

        <div class="row py-2" *ngFor="let item of dataToShow">
          <div class="col-4"><strong>{{ item['key'] }}:</strong></div>
          <div class="col-4">{{ item['count'] }}</div>
          <div class="col-4" *ngIf="item['duration']">{{ item['duration'] }}</div>
        </div>

      </div>
    </div>
  </mat-dialog-content>
</div>
